import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ModalComponent } from '../../../ui/modal-component/modal-component.component';
import { FormWrapperComponent } from '../../../ui/form-wrapper/form-wrapper.component';
import { InputFieldComponent } from '../../../ui/inputField/inputField.component';
import {
  FormBuilder,
  FormGroup,
  FormArray,
  FormControl,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CustomizableButtonComponent } from '../../../ui/customizable-button/customizable-button.component';
import { CampaignsService } from '../../../../services/campaign/campaigns-api.service';
import { ActivatedRoute } from '@angular/router';
import { CampaignDetails } from '../../../../pages/organization/campaigns/types/campaignDetails';

interface GoalsType {
  id: number;
  name: string | null;
  engagementCampaigns: any[];
}

@Component({
  selector: 'app-edit-goals',
  standalone: true,
  imports: [
    MatTooltipModule,
    ModalComponent,
    FormWrapperComponent,
    InputFieldComponent,
    ReactiveFormsModule,
    CustomizableButtonComponent,
  ],
  templateUrl: './edit-goals.component.html',
  styleUrl: '../campaign-form.css',
})
export class EditGoalsComponent implements OnInit {
  @Output() onClose = new EventEmitter();
  @Input({ required: true }) openModal = false;
  @Input() campaignGoals: GoalsType[] = [];
  campaignsService = inject(CampaignsService);
  @Input() campaignData!: CampaignDetails;

  constructor(private fb: FormBuilder, private route: ActivatedRoute) {}

  goalsForm = this.fb.group({
    goals: this.fb.array([]),
  });

  get goals() {
    return this.goalsForm.get('goals') as FormArray;
  }

  addGoal(): void {
    this.goals.push(this.fb.control('', Validators.required)); // Add an empty goal field
  }

  removeGoal(index: number): void {
    this.goals.removeAt(index); // Remove a specific goal field
  }

  replaceNameWithGoals(goals: string[], objects: any[]): any[] {
    return objects.map((obj, index) => ({
      ...obj, // Spread the existing properties
      name: goals[index], // Replace the name property with the corresponding goal
    }));
  }

  submitted = false;

  onSubmit() {
    this.submitted = true;
    if (this.goalsForm.invalid) return;
    const engagementObjectives = this.replaceNameWithGoals(
      this.goals.controls.map((goal) => goal.value),
      this.campaignGoals
    );
    const data = {
      ...this.campaignData,
      engagementObjectives: this.goals.controls.map((goal) => {
        return { name: goal.value };
      }),
    };
    this.campaignsService
      .editCampaign(this.campaignData.id, data, false)
      .subscribe(() => {
        this.onClose.emit();
      });
  }

  setGoals(goals?: GoalsType[]) {
    goals?.forEach((goal) => {
      this.goals.push(this.fb.control(goal.name, Validators.required));
    });
  }

  ngOnInit() {
    this.setGoals(this.campaignGoals);
  }
}
